const appActions = {
  SET_INITIALIZED: 'SET_INITIALIZED',

  SET_APP_TOAST_MESSAGE: 'SET_APP_TOAST_MESSAGE'
} as const

export default appActions
